import { prop, filter, find, pipe, compose, eq } from 'src/utils';
import slugify from 'slugify';

const getFrontmatter = prop('markdownRemark.frontmatter');

const findByLang = (lang) => find(compose(eq(lang), prop('lang')));

const filterAcitve = filter(prop('active'));

export function getPage(data, lang) {
  const frontmatter = getFrontmatter(data);
  if (!frontmatter) {
    return { title: null, pageData: null };
  }

  const { title, translations } = frontmatter;
  const pageData = pipe(translations, filterAcitve, findByLang(lang));

  return { title, pageData };
}

export function createSlug(lang, name) {
  return `/${lang}/${slugify(name, { lower: true, remove: /[*+~.()'"!:@/]/g })}`;
}
